/**
 * Created by mac on 7/26/18
 */

const RewardWindow = CleverappsWindow.extend({
    ctor: function (reward, options) {
        this.options = options = options || {};
        this.reward = reward instanceof RewardsList ? reward : new RewardsList(reward, {
            ...options,
            fromRewardWindow: true,
            withoutSidebar: cleverapps.resolution.isVertical()
        });
        this.reward.receiveRewards();

        cleverapps.dataLoader.processSaveQueue();

        this._super();
    },

    onWindowLoaded: function () {
        this._super({
            title: this.options.title || Messages.get("RewardWindow.title"),
            name: this.options.name || "rewardwindow",
            content: this.createContent(),
            noBackground: true,
            tapToContinueText: "Window.ClickToClaim",
            shareId: this.options.shareId || this.reward.isBigReward() && "reward",
            showSound: this.options.sound || bundles.main.urls.reward_window_effect,
            fireworks: this.options.fireworks,
            closeButtonManual: true
        });

        this.adjustRewardList();
    },

    onShow: function () {
        this._super();

        if (this.rewardChest) {
            if (this.rewardChest.hasAnimation("idle")) {
                this.rewardChest.setAnimationAndIdleAfter("open", "idle");
            } else {
                this.rewardChest.setAnimation(0, "open", false);
            }

            cleverapps.effects.fire("reward.window.chest.open");
        }

        let delay = 0;
        if (this.rewardChest) {
            const styles = cleverapps.styles.RewardWindow.rewardChest;
            delay = styles && styles.delay !== undefined ? styles.delay : this.rewardChest.getAnimationDuration("open") * 0.5;
        }
        this.rewardsList.setVisible(false);
        this.runAction(new cc.Sequence(
            new cc.DelayTime(delay),
            new cc.CallFunc(() => {
                this.rewardsList.setVisible(true);
                this.rewardsList.showUp(this.delayedShowUp.bind(this), {
                    source: this.rewardChest
                });
            })
        ));
    },

    adjustRewardList: function () {
        const width = this.rewardsList.width * this.rewardsList.scale;
        if (width > this.window.width) {
            this.rewardsList.setScale(this.rewardsList.scale * this.window.width / width);
        }
    },

    createContent: function () {
        const styles = cleverapps.styles.RewardWindow;

        let text;

        if (this.options.text) {
            // eslint-disable-next-line no-restricted-syntax
            text = this.rewardText = cleverapps.UI.generateTTFText(this.options.text, cleverapps.styles.FONTS.REWARDWINDOW_TITLE_TEXT);
            text.setWrapWidth(styles.textWidth);
            text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        }

        this.rewardsList = this.createRewardsList();

        this.rewardChest = this.createRewardChest();

        const contentNodes = [text, this.rewardsList];

        if (styles.rewardChest && styles.rewardChest.overlayPosition) {
            this.addChild(this.rewardChest);
            this.rewardChest.setAlignment(styles.rewardChest.overlayPosition);
        } else {
            contentNodes.push(this.rewardChest);
        }

        return new cleverapps.Layout(contentNodes.filter(Boolean), {
            padding: styles.padding,
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    onResize: function () {
        this._super();
        if (this.rewardChest) {
            this.rewardChest.removeFromParent();
            delete this.rewardChest;
        }
    },

    getPerson: function () {
        return {
            role: "hero",
            emotion: "happy"
        };
    },

    createRewardsList: function () {
        const styles = cleverapps.styles.RewardWindow.rewards;
        return new RewardsListComponent(this.reward, {
            font: cleverapps.styles.FONTS.REWARDWINDOW_VALUE_TEXT,
            iconWrap: styles.iconWrap,
            margin: styles.margin,
            textMargin: styles.textMargin,
            toMainWorld: this.options.toMainWorld,
            shine: true,
            columns: "auto",
            fitToBox: styles.fitToBox[cleverapps.resolution.mode],
            filterCustomAnimation: true
        });
    },

    createRewardChest: function () {
        const json = bundles.reward_window.jsons.reward_chest_json;
        if (!json) {
            return;
        }

        const rewardChest = new cleverapps.Spine(bundles.reward_window.jsons.reward_chest_json);
        rewardChest.setLocalZOrder(-1);
        return rewardChest;
    },

    onClose: function () {
        if (this.reward) {
            this.reward.onAnimationFinished();
            this.reward = undefined;
        }

        if (this.options.callback) {
            this.options.callback();
        }

        this._super();
    },

    createReceiveAction: function () {
        const receiveRewardsAction = this.rewardsList.receiveRewardsAction({
            landHaptic: "reward.land",
            collectHaptic: "reward.collect"
        });
        return new cc.Sequence(
            new cc.CallFunc(() => {
                this.rewardsList.runAction(receiveRewardsAction);
            }),
            new cc.DelayTime(receiveRewardsAction.getDuration() + 0.01)
        );
    },

    createCloseAction: function (flyingUnderShadow) {
        return new cc.Sequence(
            new cc.CallFunc(() => {
                if (this.persons) {
                    this.persons.hide();
                    delete this.persons;
                }

                if (this.rewardText) {
                    this.rewardText.runAction(new cc.FadeOut(0.3));
                }

                if (this.windowTitle) {
                    this.windowTitle.hide();
                }

                if (this.rewardChest) {
                    if (this.rewardChest.hasAnimation("close")) {
                        this.rewardChest.setAnimation(0, "close", false);

                        cleverapps.effects.fire("reward.window.chest.close");
                    }
                    this.rewardChest.setCompleteListenerRemove();
                    delete this.rewardChest;
                }
            }),
            new cc.CallFunc(() => {
                if (this.withShadow && flyingUnderShadow) {
                    cleverapps.shadow.hide();
                }
            }),
            new cc.DelayTime(0.3),
            new cc.FadeOut(0.3),
            new cc.CallFunc(() => {
                const windowComponent = ComponentMap.get(this, WindowComponent);
                windowComponent.hideWindow();
            })
        );
    },

    beforeCloseAnimation: function (callback) {
        if (!this.reward) {
            callback();
            return;
        }

        const reward = this.reward;
        this.reward = undefined;

        const receiveAction = this.createReceiveAction();

        let actions;
        const index = reward.underShadowRewardIndex();
        if (index !== -1) {
            actions = new cc.Spawn(
                receiveAction,
                new cc.Sequence(
                    new cc.DelayTime(0.2 + 0.3 * index),
                    this.createCloseAction(true)
                )
            );
        } else {
            actions = new cc.Sequence(receiveAction, this.createCloseAction());
        }
        actions = new cc.Sequence(actions, new cc.CallFunc(callback || (() => {})));

        this.runAction(actions).setFinalize(() => reward.updateViewAmount());
    },

    onPressed: function () {
        this.close();
    },

    listBundles: function () {
        return ["reward_window"].concat(this.reward.listBundles());
    },

    getPreferredBundles: function () {
        if (["merge", "merge2"].includes(cleverapps.config.type)) {
            return ["game", "main", "ui"];
        }
        return this._super();
    }
});

RewardWindow.createPurchaseWindow = function (reward) {
    return new RewardWindow(reward, {
        title: Messages.get("PurchaseRewardWindow.title"),
        name: "purchaserewardwindow",
        event: cleverapps.EVENTS.EARN.PURCHASE
    });
};

RewardWindow.createAdsRewardWindow = function (reward) {
    return new RewardWindow(reward, {
        title: Messages.get("RewardWindow.title"),
        name: "purchaserewardwindow",
        event: cleverapps.EVENTS.EARN.PURCHASE
    });
};

// the same window for a purchase the store delivered late: the title says so, the text explains
RewardWindow.createRestoredWindow = function (reward) {
    return new RewardWindow(reward, {
        title: Messages.get("PurchaseRestoredWindow.title"),
        text: Messages.get("PurchaseRestoredWindow.text"),
        name: "purchaserewardwindow",
        event: cleverapps.EVENTS.EARN.PURCHASE
    });
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    REWARDWINDOW_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    REWARDWINDOW_VALUE_TEXT: {
        size: 56,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    }
});

cleverapps.styles.RewardWindow = {
    textWidth: 800,
    margin: 40,

    rewards: {
        iconWrap: {
            height: 130
        },

        margin: {
            x: 100,
            y: 60
        },

        fitToBox: [
            { width: 650, height: 650 },
            { width: 1200, height: 650 },
            { width: 1500, height: 650 }
        ],

        textMargin: 0
    },

    padding: {
        right: 20,
        left: 20,
        top: 60,
        bottom: 60
    }
};
